export {default as color, rgb, hsl} from "./src/color";
export {default as lab, hcl} from "./src/lab";
export {default as cubehelix} from "./src/cubehelix";



//////////////////
// WEBPACK FOOTER
// ./~/d3-color/index.js
// module id = 90
// module chunks = 1